import React, { Component } from "react";
import ReactDOM from "react-dom";
import SearchSettings from "../../app/javascript/components/SearchSettings";
import SearchResults from "../../app/javascript/components/SearchResults";
import Map from "../../app/javascript/components/map";

// TODO: Context API to share shops, query, radius with all children
class FindShops extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: "",
      radius: 20,
      center: {},
      shops: [],
      filters: [],
      isLoading: false,
      error: null,
    };
  }

  componentDidMount() {
    const { query, radius, shops, center } = this.props;
    this.setState({
      query,
      radius,
      center,
      shops: this.filterNullShops(shops),
    });
  }

  // Helper method to filter out null or undefined shops
  filterNullShops = (shops) => (shops || []).filter((shop) => shop !== null);

  handleChange = (event) => {
    const { id, value } = event.target;
    this.setState({ [id]: value });
  };

  handleFilterChange = (event) => {
    const {
      dataset: { name },
      checked,
    } = event.target;

    // Don't mutate state arrays directly
    this.setState((prev) => {
      const next = checked
        ? [...prev.filters, name]
        : prev.filters.filter((f) => f !== name);

      return { filters: [...new Set(next)] };
    });
  };

  handleSubmit = async (event) => {
    if (event?.preventDefault) event.preventDefault();

    const { query, radius } = this.state;

    utagClick({ event_action: "search", event_label: query });
    utagClick({
      event_category: "home",
      event_action: "find a technet shop near you form",
      event_label: query,
    });

    // clear old results immediately + show spinner
    this.setState({
      isLoading: true,
      error: null,
      shops: [],
    });

    try {
      const results = await fetch(
        `/api/v1/shops?q=${encodeURIComponent(query)}&r=${encodeURIComponent(radius)}`,
      );

      const { shops, center } = await results.json();

      this.setState({
        shops: this.filterNullShops(shops),
        center,
      });
    } catch (err) {
      console.error(err);
      this.setState({ error: err });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { query, radius, center, shops: s, filters, isLoading } = this.state;
    const { apiKey, mapId } = this.props;

    // Apply filters and ensure shops are filtered for nulls
    const shops = this.filterNullShops(
      !filters.length
        ? s
        : s.filter((shop) => {
            const services = Object.assign({}, shop.services, shop.specialties);
            return filters.every((filter) => services[filter]);
          }),
    );

    return (
      <div>
        <Map
          apiKey={apiKey}
          mapId={mapId}
          center={center}
          shops={shops}
          zoom={12}
        />

        <SearchSettings
          query={query}
          radius={radius}
          shops={shops}
          isLoading={isLoading}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          handleFilterChange={this.handleFilterChange}
        />

        <SearchResults
          query={query}
          radius={radius}
          shops={shops}
          isLoading={isLoading}
        />
      </div>
    );
  }
}

FindShops.defaultProps = {
  shops: [],
  center: {
    lat: 0,
    lng: 0,
  },
  query: "",
  radius: 20,
  apiKey: "",
  mapId: "",
};

document.addEventListener("DOMContentLoaded", () => {
  const node = document.getElementById("map");
  const props = JSON.parse(node.getAttribute("props"));

  ReactDOM.render(<FindShops {...props} />, node);
});
